import React, { useState } from 'react';
import styles from './AddData.module.css';
import { BsThreeDots } from 'react-icons/bs';

const AddData = ({ data }) => {
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const toggleAll = () => {
    if (selectedAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((_, index) => index));
    }
    setSelectedAll(!selectedAll);
  };

  const toggleOne = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter(i => i !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead className={styles.headerWrapper}>
          <tr className={styles.headerRow}>
            <th className={styles.cell}><input type="checkbox" className={styles.checkbox} checked={selectedAll} onChange={toggleAll} /></th>
            <th className={styles.cell}>Student Name</th>
            <th className={styles.cell}>Relation with student</th>
            <th className={styles.cell}>Mobile number</th>
            <th className={styles.cell}>Email Id</th>
            <th className={styles.cell}>Address</th>
            <th className={styles.cell}>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((entry, index) => (
            <tr className={styles.row} key={index}>
              <td className={styles.cell}><input type="checkbox" className={styles.checkbox} checked={selectedRows.includes(index)} onChange={() => toggleOne(index)} /></td>
              <td className={styles.cell}>
                <div className={styles.nameWrapper}>
                  <div className={styles.initialCircle}>{entry.name[0]}</div>
                  <span className={styles.nameText}>{entry.name}</span>
                </div>
              </td>
              <td className={styles.cell}>{entry.relation}</td>
              <td className={styles.cell}>{entry.mobile}</td>
              <td className={styles.cell}>{entry.email}</td>
              <td className={styles.cell}><div className={styles.address}>{entry.address}</div></td>
              <td className={styles.cell}><BsThreeDots className={styles.action} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AddData;